// global.BaseUrl = 'https://foodweb-shepkita.ksoftpl.com/sky-cafe/public/api';
// global.AssetsUrl = 'https://foodweb-shepkita.ksoftpl.com/sky-cafe/public';

global.BaseUrl = 'https://admin.foodweb-shepkita.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-shepkita.ksoftpl.com';

